class UpdateShippingSettingsModalController {
    constructor($injector, $uibModalInstance) {
        this.injector = $injector;
        this.uibModalInstance = $uibModalInstance;

        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');

        this.fullSettingsModel = null;
        this.currentSettingsModel = null;

        this.loading = true;
        this.blockSubmit = true
        this.loadCurrentSettings()
            .then(() => {
                this.loading = false
                this.blockSubmit = false
            });
    }

    close() {
        this.uibModalInstance.close();
    }

    async save() {
        this.blockSubmit = true;
        try {
            const response = await this.api.put('company/settings', {settings: {shipping:this.currentSettingsModel}})
            this.uibModalInstance.close();
            this.alert.success('Success', 'settings have been saved successful');
        } catch(e) {
            this.alert.handle(e);
            this.blockSubmit = false
        }
    }

    async loadCurrentSettings() {
        const response = await this.api.get('auth/profile?include=company')

        this.fullSettingsModel = _.get(response.data.data, 'company.data.settings.shipping');
        this.currentSettingsModel = this.prepareEditableSettingsModel()
    }

    prepareEditableSettingsModel() {
        switch (this.fullSettingsModel.used_shipping_provider) {
            case 1:
                return _.pick(this.fullSettingsModel, [
                    "go_earliest_pickup_date",
                    "go_abholschnitt",
                    "go_abholzeit_start",
                    "go_abholzeit_ende",
                    "go_pdf_type",
                ])
        }
    }
}

UpdateShippingSettingsModalController.$inject = [
    '$injector',
    '$uibModalInstance'
];

export default UpdateShippingSettingsModalController;


// WEBPACK FOOTER //
// ./src/app/pages/shippings/controllers/update-settings-modal-controller.js